import { render, staticRenderFns } from "./ImportAlumniWorkExperience.vue?vue&type=template&id=6df851ba&"
import script from "./ImportAlumniWorkExperience.vue?vue&type=script&lang=js&"
export * from "./ImportAlumniWorkExperience.vue?vue&type=script&lang=js&"
import style0 from "./ImportAlumniWorkExperience.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports